<!-- Divider -->
<div
	class="fuse-horizontal-navigation-item-wrapper divider"
	[ngClass]="item.classes?.wrapper"></div>
